var _linearGradient, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTestimonialWave4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 662,
    viewBox: "0 0 1440 662",
    width: 1440,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 1120.5,
    x2: 902.5,
    y1: 179.744,
    y2: 578.744
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e82539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584158,
    stopColor: "#fb4849"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ef234c"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1101.96 310.258c-212.807-81.893-215.89-115.223-386.39-93.619-170.5 21.605-273.112-90.453-438.5-108.999-165.388-18.5459-293.9474 1.824-373.07 21.604v432.742h1631.12v-249.951s-219.97 80.266-433.16-1.777z",
    fill: "url(#a)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestimonialWave4);
export default __webpack_public_path__ + "static/media/testimonial-wave4.21e3819e5ac37d91da1a61809ef3a473.svg";
export { ForwardRef as ReactComponent };